<template>
  <page-layout :title="title">
    <template v-slot:breadcrumb>
      <li><router-link :to="{ name: 'home' }">Dashboard</router-link></li>
      <li>
        <router-link :to="{ name: 'queclinkTracker.list' }"> Balises QUECLINK </router-link>
      </li>
      <li class="is-active">
        <a href="#">{{ title }}</a>
      </li>
    </template>
    <o-tabs v-if="queclinkTracker" :items="tabItems">
      <template #[TABS.GENERAL.name]>
        <queclink-tracker-information :queclink-tracker.sync="queclinkTracker" />
      </template>
      <template #[TABS.CONFIGURATION.name]>
        <queclink-tracker-config :queclink-tracker="queclinkTracker" />
      </template>
      <template #[TABS.OPERATOR.name]>
        <queclink-tracker-endpoint :queclink-tracker="queclinkTracker" />
      </template>
      <template #[TABS.STATISTICS.name]>
        <queclink-tracker-statistics :queclink-tracker="queclinkTracker" />
      </template>
    </o-tabs>
  </page-layout>
</template>

<script>
import OTabs from '@components/Tabs.vue'
import PageLayout from '@components/PageLayout.vue'
import QueclinkTrackerConfig from './QueclinkTrackerConfig'
import QueclinkTrackerEndpoint from './QueclinkTrackerEndpoint'
import QueclinkTrackerInformation from './QueclinkTrackerInformation'
import QueclinkTrackerStatistics from './QueclinkTrackerStatistics'

export default {
  name: 'EditQueclinkTrackerPage',

  components: {
    OTabs,
    PageLayout,
    QueclinkTrackerConfig,
    QueclinkTrackerEndpoint,
    QueclinkTrackerInformation,
    QueclinkTrackerStatistics,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      queclinkTracker: null,
    }
  },

  created() {
    this.TABS = {
      GENERAL: { label: 'Général', name: 'general' },
      CONFIGURATION: { label: 'Configuration', name: 'configuration' },
      OPERATOR: { label: 'Opérateur', name: 'operator' },
      STATISTICS: { label: 'Statistiques', name: 'statistics' },
    }
    this.tabItems = Object.values(this.TABS)
  },

  watch: {
    id: {
      handler: 'load',
      immediate: true,
    },
  },

  computed: {
    title() {
      return this.queclinkTracker ? `QUECLINK ${this.queclinkTracker.number}` : '...'
    },
  },

  methods: {
    async load() {
      this.loading = true

      this.queclinkTracker = await this.$services.queclinkTrackerService.getById(this.id)

      this.loading = false
    },
  },
}
</script>
